import { useMsal } from "@azure/msal-react";
import React, { useEffect, useState } from 'react';
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import axios from 'axios';


export async function acquireGetAccessToken(instance:any, accounts:any) {
    let activeAccount = instance.getActiveAccount();

    if (!activeAccount && accounts.length === 0) {
        console.log('No active account found, triggering login...');
        await instance.loginRedirect();
        return; // Stop function execution after triggering redirect
    }

    if (!activeAccount) {
        // Set the first account as the active account if there's no active account
        activeAccount = accounts[0];
        instance.setActiveAccount(activeAccount);
    }

    const request = {
        scopes: [`${process.env.REACT_APP_API_SCOPE1}`],
        account: activeAccount || accounts[0]
    };
    const requestProfile = {
        scopes: ["User.Read"],
        account: activeAccount || accounts[0]
    };

    try {
        // Try to acquire token silently
        const authResult = await instance.acquireTokenSilent(request);
        const authResultProfile = await instance.acquireTokenSilent(requestProfile);
        localStorage.setItem("accessToken", authResult.accessToken);
        sessionStorage.setItem("accessToken", authResult.accessToken);
        localStorage.setItem("accessProfileToken", authResultProfile.accessToken);

        return {'accessToken':authResult.accessToken,'accessTokenProfile': authResultProfile.accessToken};
    } catch (error: any) {
        console.error("Error acquiring token silently:", error);

        // Handle error if interaction is required
        if (error instanceof InteractionRequiredAuthError) {
            console.log("Interaction required, redirecting...");
            await instance.acquireTokenRedirect(request);
        } else {
            // Handle other errors
            console.error("Token acquisition error:", error);
        }
    }
}

// Function to be called from your component
export function useAcquireGetAccessToken() {
    const { inProgress, instance, accounts } = useMsal();
    const [profile, setProfile] = useState({ jobTitle: "" });
    const [photoData, setPhotoData] = useState("");

    const getAccessTokenAsync = async () => {
        // Check if another MSAL process is in progress to avoid double triggering
        if (inProgress === "none") {
            return await acquireGetAccessToken(instance, accounts);
        } else {
            console.log("MSAL interaction in progress, skipping token acquisition");
            return null;
        }
    };
    
    return getAccessTokenAsync;
}

